import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form, useFormik } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPostsById } from "../../../../redux/posts/action";
import { postContestEntry } from "../../../../redux/contest/action";
import { descriptionvalidation, titlevalidation } from "../../../Common/commonvalidation";
import AllTypeFilesUpload from "../../../Common/Upload/AllTypeFilesUpload";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import HomeCommonNavigation from "../../../Common/HomeCommonNavigation";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";

// Added Imports for the Popup
import { Modal } from "reactstrap";
import ContractView from "../../../CustomComponents/ContractView";
import PopupContractPrivacyPolicy from "../../../Common/PopupContractPrivacyPolicy";
import SignContractInput from "../../../Common/SignContractInput";

export default function SubmitContestEntry() {
  const path = "Assets/scss/searchcontestparticipate.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [work_sample, setWork_sample] = useState();
  const [loading, setLoading] = useState(false);

  const laung = localStorage.getItem("laung") || "en";
  const [lan, setLan] = useState(laung);
  const navigate = useNavigate();
  const { id } = useParams();
  
  // Selectors
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata); // Added to fetch profile for signature
  const dispatch = useDispatch();

  // State for popups and temporarily holding the main form data
  const [contractModal, setContractModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);
  const [tempMainData, setTempMainData] = useState(null);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  const initialValues = {
    message: "",
    title: "",
    licensed: "",
    files: "",
  };

  const validationSchema = Yup.object().shape({
    message: descriptionvalidation,
    title: titlevalidation,
    licensed: Yup.string()
      .oneOf(["1", "2"], "Licensed content is required")
      .required("Licensed content is required"),
    files: Yup.array().test(
      "files-required",
      "At least one file is required",
      (value) => {
        return value && value.length > 0;
      },
    ),
  });

  // Step 1: Intercept main form submission to open the contract modal
  const handleInitialSubmit = (values) => {
    setTempMainData(values);
    setContractModal(true);
  };

  // Step 2: Formik configuration for the Signature Popup
  const signFormik = useFormik({
    initialValues: {
      first_name: profile?.first_name || "",
      last_name: profile?.last_name || "",
      agree: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      agree: Yup.boolean().oneOf([true], "You must agree to the terms"),
    }),
    onSubmit: async (signValues) => {
      // Merge tempMainData, signature details, and the rest of the required payload
      const data = {
        ...tempMainData,
        files: work_sample?.files,
        post_id: posts.id,
        type: 2,
        url: `/${lan}/praposedsuccessful`,
        first_name: signValues.first_name,
        last_name: signValues.last_name,
        image: "image.png",
      };
      
      // Dispatch the actual API call
      dispatch(postContestEntry(data, setLoading, navigate));
      
      // Close the modal
      setContractModal(false);
    },
  });

  useEffect(() => {
    setWork_sample(work_sample);
  }, [work_sample]);

  useEffect(() => {
    if (Array.isArray(posts?.my_proposal) && posts?.my_proposal?.length > 0) {
      navigate(`/${lan}/contestdetails/${posts.id}`);
    }
  }, [posts, posts?.my_proposal, posts?.my_proposal?.length]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleInitialSubmit} // Changed to trigger modal
      >
        {(formik) => (
          <Form className="project-details col-lg-10 mx-auto">
            <p className="breadcrumbs">
              <HomeCommonNavigation type={posts?.type} />
              <a onClick={() => navigate(`/${lan}/contestdetails/${posts.id}`)}>
                WBO details &gt;
              </a>
              Submit entry
            </p>
            <div className="col-lg-10  mx-auto ">
              <div className="submit-entry">
                <h5>Submit entry</h5>
                <h2>{posts.title}</h2>
                <div className="col-lg-8 mx-auto">
                  <h6>Add files <AsteriskLabel /></h6>

                  <AllTypeFilesUpload
                    formik={formik}
                    setWork_sample={setWork_sample}
                    selectedfiles={work_sample?.files}
                  />
                  {formik.errors.files && (
                    <p style={{ color: "red", fontSize: 16 }}>
                      {formik.errors.files}
                    </p>
                  )}
                  <div className="form-group">
                    <label>Entry Title <AsteriskLabel /></label>
                    <Field
                      type="text"
                      className="form-control"
                      name="title"
                      placeholder="Enter entry title"
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="error"
                    />
                  </div>
                  <div className="form-group">
                    <label>Description <AsteriskLabel /></label>
                    <Field
                      as="textarea"
                      className="form-control"
                      name="message"
                      placeholder="Enter description here"
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="error"
                    />
                  </div>
                  <h6 className="license">Licensed Content <AsteriskLabel /></h6>
                  <p>Declare any stock content used to avoid penalty.</p>
                  
                  <div className="radio-btn">
                    <Field type="radio" id="entry" name="licensed" value="1" />
                    <label htmlFor="entry">This entry is entirely my own.</label>
                  </div>
                  <div className="radio-btn">
                    <Field type="radio" id="element" name="licensed" value="2" />
                    <label htmlFor="element">
                      This entry contains elements I did not create.
                    </label>
                  </div>
                  <ErrorMessage
                    name="licensed"
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <div className="entry-btn">
                <button
                  type="button"
                  className="btn"
                  disabled={loading}
                  onClick={() => navigate(`/${lan}/contestdetails/${posts.id}`)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn" disabled={loading}>
                  {loading ? (
                    <LoginLoaderButton />
                  ) : (
                    <>
                      Submit entry
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                        alt=""
                      />
                    </>
                  )}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      {/* ---------------- Contract Modal ---------------- */}
      {contractModal && (
        <Modal
          isOpen={contractModal}
          size="lg"
          className="modal-centered contract-modal contract"
          toggle={() => setContractModal(false)}
        >
          <div className="contract-sec p-4" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="website-design mb-4">
              {/* Changed type to contest_agreement */}
              <ContractView type={'contest_agreement'} /> 
            </div>

            <form onSubmit={signFormik.handleSubmit}>
              <SignContractInput formik={signFormik} />

              <div className="checkbox mt-3">
                <input
                  type="checkbox"
                  id="agree"
                  name="agree"
                  checked={signFormik.values.agree}
                  readOnly 
                  onClick={() => {
                    if (!signFormik.values.agree) {
                      setPrivacyModal(true);
                    } else {
                      signFormik.setFieldValue("agree", !signFormik.values.agree);
                    }
                  }}
                />
                <label htmlFor="agree">
                  Yes, I understand and agree to Urxprt’s <span> Terms of Service</span>, 
                  including the <span> User Agreement</span> and <span>Privacy Policy</span>.
                </label>
                {signFormik.touched.agree && signFormik.errors.agree ? (
                  <div className="error text-danger">{signFormik.errors.agree}</div>
                ) : null}
              </div>

              <div className="submit-btn mt-4 d-flex justify-content-end" style={{ gap: "10px" }}>
                <button
                  type="button"
                  className="btn"
                  onClick={() => setContractModal(false)}
                >
                  Back
                </button>
                <button type="submit" className="btn post-btn" disabled={loading}>
                  {loading ? <LoginLoaderButton /> : "Accept & Publish"}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      )}

      {/* ---------------- Privacy Policy Nested Modal ---------------- */}
      {privacyModal && (
        <Modal
          isOpen={privacyModal}
          keyboard={false}
          className="modal-width modal-centered popupmodal termsconditionmodal"
           modalClassName="ter-over"
        >
          <PopupContractPrivacyPolicy formik={signFormik} setModal={setPrivacyModal} />
        </Modal>
      )}
    </>
  );
}